import Axios from 'configs/Axios';
import { ItemsResponse } from 'types/ItemsWithCountResponse';
import { DateOnlyISOString } from '../utils/dateUtil';

export type WaitingListDataEntry = {
  from_hour: number;
  reservation_date: string;
  to_hour: number;
  user_member_id: string;
  cancel_other_appts: boolean;
};
export type WaitingListData = WaitingListDataEntry[];

export type WaitingListResponse = ItemsResponse<WaitingListDataEntry>;

export const saveWaitingList = (data: WaitingListData) =>
  Axios.post<WaitingListData>(`/waitingList`, data);

export type DeleteWaitingListParams = {
  memberId: string;
};
export const deleteWaitingList = (params: DeleteWaitingListParams) =>
  Axios.delete(`/waitingList/${params.memberId}`);

export type GetWaitingListParams = { memberId: string };
export const getWaitingList = (params: GetWaitingListParams) =>
  Axios.get<WaitingListData>(`/waitingList/${params.memberId}`);

export type WaitingListCountDataEntry = {
  date: DateOnlyISOString;
  count: number;
};
export type WaitingListCountData = WaitingListCountDataEntry[];
export type WaitingListCountResponse = ItemsResponse<WaitingListCountDataEntry>;

export const getWaitingListCount = () =>
  Axios.get<WaitingListCountData>(`/waitingList/count`);
